import Big from 'big.js'

export const setup = () => {
  Big.NE = -18
}
